import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
//newJoineeIdForAction
import {newJoineeTableReady,rowsPerPageState,searchTextState,paginationState,previousFilterStartDate,previousFilterEndDate,previousFilterCity,previousWorkLocationId,previousFilterStatus} from '../redux/newjoinee'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/newJoineeTable.css'



import { NewJoineeResponder } from './ActionButtons'


import {Cities,Kitchens,EntityStatus} from '../../../common/DropDowns/index'



import { CSVLink } from 'react-csv'
import { createXLSheetdata,createXLSheetdataForAcademy } from '../services/helpers'


import * as Helpers from '../../../common/helpers'


import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'


function filterUnwantedData(newJoineeData,user) {
    let array = []
    if (newJoineeData && newJoineeData.data && newJoineeData.data.list) {
        array = newJoineeData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.employee_id = lineData.employee_id ? lineData.employee_id : ""
            newLineData.employee_name = lineData.employee  && lineData.employee.name ? lineData.employee.name : ""
            newLineData.employee_code = lineData.employee  && lineData.employee.code ? lineData.employee.code : ""
            newLineData.approver = lineData.approver  && lineData.approver.name ? lineData.approver.name+" - "+lineData.approver.code : ""



            newLineData.employee_mobile = lineData.employee  && lineData.employee.mobile ? lineData.employee.mobile : ""


            newLineData.reason_name = lineData.reason  && lineData.reason.name ? lineData.reason.name : ""

            newLineData.status = lineData.status ? lineData.status : ""

            newLineData.status_remarks = lineData.status_remarks ? lineData.status_remarks : ""

            if(newLineData.status==="REJECTED"){

            newLineData.status_reason =  newLineData.reason_name + " - [ "+ newLineData.status_remarks+" ] "
            }else{

             newLineData.status_reason =  newLineData.status_remarks
            }



            newLineData.gender = lineData.employee  && lineData.employee.gender ? lineData.employee.gender : ""

            newLineData.email = lineData.employee  && lineData.employee.email ? lineData.employee.email : ""

            newLineData.doj = lineData.employee  && lineData.employee.doj ? Helpers.getDateFormatForUTC(lineData.employee.doj): ""
            newLineData.dob = lineData.employee  && lineData.employee.dob ? Helpers.getDateFormatForUTC(lineData.employee.dob): ""

            newLineData.designation = lineData.employee  && lineData.employee.designation && lineData.employee.designation.name ? lineData.employee.designation.name : ""


            newLineData.kitchen_work_location_name = lineData.kitchen_work_location && lineData.kitchen_work_location.name ? lineData.kitchen_work_location.name : ""

            newLineData.kitchen_work_location_code = lineData.kitchen_work_location && lineData.kitchen_work_location.code ? lineData.kitchen_work_location.code : ""

            newLineData.kitchen= newLineData.kitchen_work_location_name +" - " + newLineData.kitchen_work_location_code


            newLineData.created_on = lineData.created ? Helpers.getDateTimeFormatForUTC(lineData.created) : ""
            newLineData.modified_on = lineData.modified ? Helpers.getDateTimeFormatForUTC(lineData.modified) : ""

            newArray[i] = newLineData
        }
    }
    return newArray
}


function filterBBAcademyData(newJoineeData) {
    let array = []
    
        for (let i = 0; i < newJoineeData.length; i++) {
            if(newJoineeData[i]['status']==="REPORTED"){
                let newLineData = {}
                let lineData = newJoineeData[i]
                newLineData.employee_code = lineData.employee_code ? lineData.employee_code : ""
                newLineData.employee_name = lineData.employee_name ? lineData.employee_name : ""
                newLineData.dob = lineData.dob ? lineData.dob : ""
                newLineData.gender = lineData.gender ? lineData.gender : ""
                newLineData.email = lineData.email ? lineData.email : ""
                newLineData.employee_mobile = lineData.employee_mobile ? lineData.employee_mobile : ""
                newLineData.designation = lineData.designation ? lineData.designation : ""
                newLineData.doj = lineData.doj ? lineData.doj : ""
                newLineData.kitchen_code = lineData.kitchen_work_location_code ? lineData.kitchen_work_location_code : ""
                array.push(newLineData);
            }

        }
    return array
}


class NewJoineeTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            newJoineeData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_movement:"",
            filter_status:"",
            workLocationId:"", 
            hbbAcademyData:[],          
            filter_cityId:0,
            startDate: moment().startOf('month').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            ranges: {
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            rowCount: 15,            
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null


        this.CSVData = []
        this.CSVDataAcademy = []
        this.createCSVData = this.createCSVData.bind(this)
        this.createCSVDataForAcademy = this.createCSVDataForAcademy.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(newJoineeTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.NEW_JOINEE_TABLE))

        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()


        let previousFilterStartDate=moment().startOf('month').format("YYYY-MM-DD")
        let previousFilterEndDate=moment().format("YYYY-MM-DD")
        let previousWorkLocationId=""
        let filter_cityId=0
        let filter_status=""

        if (this.props.newjoinee && this.props.newjoinee.previousFilterCity && this.props.newjoinee.previousFilterCity!==undefined) {
            filter_cityId=this.props.newjoinee.previousFilterCity
         }

         if (this.props.newjoinee && this.props.newjoinee.previousWorkLocationId && this.props.newjoinee.previousWorkLocationId!==undefined) {
            previousWorkLocationId=this.props.newjoinee.previousWorkLocationId
         }

         if (this.props.newjoinee && this.props.newjoinee.previousFilterStartDate && this.props.newjoinee.previousFilterStartDate!==undefined) {
            previousFilterStartDate=this.props.newjoinee.previousFilterStartDate
         }
         if (this.props.newjoinee && this.props.newjoinee.previousFilterEndDate && this.props.newjoinee.previousFilterEndDate!==undefined) {
            previousFilterEndDate=this.props.newjoinee.previousFilterEndDate
         }
         if (this.props.newjoinee && this.props.newjoinee.previousFilterStatus && this.props.newjoinee.previousFilterStatus!==undefined) {
            filter_status=this.props.newjoinee.previousFilterStatus
         }

         this.setState({
              startDate:previousFilterStartDate,
              endDate:previousFilterEndDate,
              filter_cityId:filter_cityId,
              workLocationId:previousWorkLocationId,
              filter_status:filter_status
         },() => {
            this.getNewJoineeData()
        });

        
    }

    componentDidMount() {

    }



       cityChange = (data) => {
        

        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterCity(""))
             this.setState({
                filter_cityId:"",
                workLocationId:""
            },() => {
                this.props.dispatch(previousFilterCity(""))
                this.props.dispatch(previousWorkLocationId(""))
                this.getNewJoineeData();
            });

        }else{
            this.props.dispatch(previousFilterCity(data.value))
            this.setState({
                filter_cityId:data.value
            })
        }
    }

      kitchenChange = (data) => {
        
         if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousWorkLocationId(""))
             this.setState({
                workLocationId:""
            })
        }else{
            this.props.dispatch(previousWorkLocationId(data.value))
            this.setState({
                workLocationId:data.value
            })
        }
    }

     entityStatusChange = (data) => {
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterStatus(""))
             this.setState({
                filter_status :"",            
            })
        }else{
            this.props.dispatch(previousFilterStatus(data.value))
            this.setState({
                filter_status :data.value,            
            })
        }
    }


    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 260) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getNewJoineeData = () => {
        apiService.getNewJoineeData(this.state.startDate,this.state.endDate,this.state.filter_cityId,this.state.workLocationId,this.state.filter_status)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData,this.props.user), pageNo = 1
                        let array2=filterBBAcademyData(array)
                        
                        if (this.props.newjoinee && this.props.newjoinee.previousPaginationValue) {
                            pageNo = this.props.newjoinee.previousPaginationValue
                        }
                        this.setState({
                            newJoineeData: array,
                            page: pageNo,
                            hbbAcademyData:array2
                        })                        

                        this.createCSVData(array)
                        this.createCSVDataForAcademy(array2)
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(newJoineeTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(newJoineeTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

      createCSVData(csvData) {
        let movementList = []
        if (csvData) {
            movementList = JSON.parse(JSON.stringify(csvData))
            movementList = createXLSheetdata(movementList)
        }
        this.CSVData = movementList
    }

      createCSVDataForAcademy(csvData) {
        let movementList = []
        if (csvData) {
            movementList = JSON.parse(JSON.stringify(csvData))
            movementList = createXLSheetdataForAcademy(movementList)
        }
        this.CSVDataAcademy = movementList
    }







    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.newjoinee && this.props.newjoinee.previousRowsPerPageValue) {
            value = this.props.newjoinee.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

    movementFromToChange = (data) => {

        this.setState({
            filter_movement :data.value,
            
        })
    }


renderMovementReason = (cell, row, enumObject, rowIndex,) => {
        
        let reason=""
        
            reason=<p>{row.movement_reason}<br/>[ {row.movement_remarks} ]</p>

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{reason}</div>
        </div>)
    }






    actionButtonsCreator = (cell, row) => {
        
        let responBtn=""

        if(row.status==="HIRED" && Helpers.checkPrivileges("/dashboard/newJoinee/update",this.props.user)){
            responBtn=<NewJoineeResponder data={row}/>

        }

      return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{responBtn}</div>
        </div>)

    }

    

   

    createCustomToolBar = props => {


        let newjoinDetailsFilename = "employee_newjoinee_data_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"

        let startDate = "", endDate = "", start = "", end = "", label = ""

        startDate = moment(this.state.startDate)
        endDate = moment(this.state.endDate)

        start = moment(startDate).format('DD-MM-YYYY')
        end = moment(endDate).format('DD-MM-YYYY')

        label = start + ' to ' + end;

        if (start === end) {
            label = start
        }

        let firstComponent = ''

        
            firstComponent = <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                <div className="form-group">
                    <DateRangePicker startDate={startDate}
                        endDate={endDate}
                        ranges={this.state.ranges}
                        showDropdowns={true}
                        onApply={this.onApplyEvent}>
                        <button className="date-picker-button">
                            <div className="pull-left"><i className="fa fa-calendar" /></div>
                            <span style={{ textAlign: 'center' }}>{label}</span>
                            <div className="pull-right">
                                <span className="caret"></span>
                            </div>
                        </button>
                    </DateRangePicker>
                </div>
            </div>


        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-div-margins">
                 {firstComponent}

                   {(() => {
                        if(Helpers.checkPrivileges("/root/filter",this.props.user)){
                            return (

                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <Cities cityChange={this.cityChange} selectedValue={this.state.filter_cityId} />
                    </div>
                      )
                        }
                    })()}



                     <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <Kitchens selectedCity={this.state.filter_cityId} kitchenChange={this.kitchenChange} selectedValue={this.state.workLocationId} />
                    </div>

                     <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <div className="form-group">
                                   <EntityStatus type="NEW_JOINEES" entityStatusChange={this.entityStatusChange} selectedValue={this.state.filter_status} />    
                                </div>
                    </div>

          
                  <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredEmployeesMomentList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>

                         {(() =>{

                        if(Helpers.checkPrivileges("/dashboard/newJoinee/list",this.props.user)){
                        return(


                            <CSVLink
                                    data={this.CSVData}
                                    className="btn btn-primary button-custom"
                                    style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                                    filename={newjoinDetailsFilename}>
                                    Export
                                </CSVLink>
                            )
                        }
                    })()}

                     {(() =>{

                        if(Helpers.checkPrivileges("/dashboard/newJoinee/bbacademy",this.props.user)){
                        return(


                            <CSVLink
                                    data={this.CSVDataAcademy}
                                    className="btn btn-primary button-custom"
                                    style={{ marginLeft: "10px",background: "#009688",border:"1px solid #009688"}}
                                    filename={newjoinDetailsFilename}>
                                    Export BB Academy Format
                                </CSVLink>
                            )
                        }
                    })()}


                    </div>  

                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                <div className="col-md-9 col-lg-9">
                </div>

                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
                    
                </div>
                
            </div>
        )
    }
    
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.newJoineeData.length>=(this.props.newjoinee.previousPaginationValue*this.props.newjoinee.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.newjoinee.previousPaginationValue*this.props.newjoinee.previousRowsPerPageValue)-this.props.newjoinee.previousRowsPerPageValue+1} to {this.props.newjoinee.previousPaginationValue*this.props.newjoinee.previousRowsPerPageValue} of {this.state.newJoineeData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.newjoinee.previousPaginationValue*this.props.newjoinee.previousRowsPerPageValue)-this.props.newjoinee.previousRowsPerPageValue+1} to {this.state.newJoineeData.length} of {this.state.newJoineeData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredEmployeesMomentList = () => {
       
        this.props.dispatch(newJoineeTableReady(false))
        this.resetSearchAndPagination()
        this.getNewJoineeData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    

    resetFilterValues = () => {
        this.props.dispatch(newJoineeTableReady(false))
        this.setState({
            startDate: moment().startOf('month').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            filter_cityId: 0,
            filter_status: "",
            workLocationId: ""
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.props.dispatch(previousFilterCity())
            this.props.dispatch(previousWorkLocationId())
            this.props.dispatch(previousFilterStatus())
            this.props.dispatch(previousFilterStartDate(moment().startOf('month').format("YYYY-MM-DD")))
            this.props.dispatch(previousFilterEndDate(moment().format("YYYY-MM-DD")))

            this.getNewJoineeData();
        })

    }




     onApplyEvent = (event, picker) => {
        let startDate = moment(picker.startDate)
        let endDate = moment(picker.endDate)

        let api_start_date=moment(picker.startDate).format("YYYY-MM-DD")
        let api_end_date=moment(picker.endDate).format("YYYY-MM-DD")
        if (endDate.diff(endDate, 'months', true) > 1) {
            this.dialog.show({
                title: "Date chosen is greater than one month",
                body: 'Please choose any Dates within one month and then try again',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        } else {
            if (startDate.isAfter(moment().add(1, 'days')) ||
                endDate.isAfter(moment().add(1, 'days'))) {
                this.dialog.show({
                    title: "Date Chosen is greater than current date",
                    body: 'Please choose any Dates within current date and then try again',
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })
            } else {

                this.props.dispatch(previousFilterStartDate(api_start_date))
                this.props.dispatch(previousFilterEndDate(api_end_date))

                this.setState({
                    startDate: api_start_date,
                    endDate: api_end_date
                })
            }
        }
    }




     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.newjoinee && this.props.newjoinee.previousPaginationValue
            && this.props.newjoinee.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }


    render() {
        let sizeperPage = 15

        if (this.props.newjoinee && this.props.newjoinee.previousRowsPerPageValue) {
            sizeperPage = this.props.newjoinee.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="newJoinee-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.newJoineeData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                     >

                      {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                    <TableHeaderColumn
                        dataField="employee_code"                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Emp Id
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="employee_name"                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="employee_mobile"                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Mobile
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataField="kitchen"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Kitchen
                    </TableHeaderColumn>
                   

                   
                    <TableHeaderColumn
                        dataField="status"                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Status
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="status_reason"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Remarks
                    </TableHeaderColumn>



                    <TableHeaderColumn
                        dataField="approver"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Responded By
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="created_on"                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Created
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        expandable={false}
                        dataFormat={this.actionButtonsCreator}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>  
                    
                    
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        newjoinee: state.newjoinee
    }
}

export default connect(mapStateToProps)(withRouter(NewJoineeTable))


// WEBPACK FOOTER //
// ./src/modules/New Joinee/Components/NewJoineeTable.js